'use strict';

var _markerclusterer = require('@google/markerclusterer');

var _markerclusterer2 = _interopRequireDefault(_markerclusterer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require('jquery');


var clusterImage = '/sitefiles/src/img/cluster-img/i';
var markerImage = '/sitefiles/src/img/g-map-icon.png';
var arrowSvg = '<svg class="icon-svg icon-arrow" viewBox="0 0 9.035 16.984"><use xlink:href="/sitefiles/src/img/svg/icon-arrow.svg#icon-arrow"></use></svg>';

var $mapViewBtn = $('.js-map-view-btn');
var $locationPopup = $('.js-location-detail');
var $locationPopupClose = $('.js-location-close');

var $locationName = $('.js-location-name');
var $locationTelephone = $('.js-location-telephone');
var $locationEmail = $('.js-location-email');
var $locationImage = $('.js-location-image');
var $locationButton = $('.js-location-button');

var mapStyles = [{
  featureType: 'administrative',
  elementType: 'labels.text.fill',
  stylers: [{ color: '#444444' }]
}, {
  featureType: 'landscape',
  elementType: 'all',
  stylers: [{ color: '#f2f2f2' }]
}, {
  featureType: 'poi',
  elementType: 'all',
  stylers: [{ visibility: 'off' }]
}, {
  featureType: 'road',
  elementType: 'all',
  stylers: [{ saturation: -100 }, { lightness: 45 }]
}, {
  featureType: 'road.highway',
  elementType: 'all',
  stylers: [{ visibility: 'simplified' }]
}, {
  featureType: 'road.arterial',
  elementType: 'labels.icon',
  stylers: [{ visibility: 'off' }]
}, {
  featureType: 'transit',
  elementType: 'all',
  stylers: [{ visibility: 'off' }]
}, {
  featureType: 'water',
  elementType: 'all',
  stylers: [{ color: '#46bcec' }, { visibility: 'on' }]
}];

var onLocationsLoaded = function onLocationsLoaded(data) {
  var $cultureCodeElem = $('[data-culture-code]');
  var $cultureCode = '';
  var $buttonText = '';
  var $latitude = 54.5110481;
  var $longitude = -4.0550972;

  if ($cultureCodeElem.length > 0) {
    $cultureCode = $cultureCodeElem.data('culture-code');
    $buttonText = $cultureCodeElem.data('button-text');
    $latitude = parseFloat($cultureCodeElem.data('latitude'));
    $longitude = parseFloat($cultureCodeElem.data('longitude'));
  }

  var locations = data.Franchises;

  var map = new google.maps.Map(document.getElementById('map-cluster-canvas'), {
    zoom: 4,
    center: {
      lat: $latitude,
      lng: $longitude
    },
    disableDefaultUI: true,
    styles: mapStyles
  });

  var markers = locations.map(function (location, i) {
    var position = new google.maps.LatLng(location.Latitude, location.Longitude);
    var marker = new google.maps.Marker({
      position: position,
      icon: markerImage
    });

    marker.addListener('click', function () {
      $locationName.text(location.Name);
      $locationTelephone.html('<a href="tel:' + location.PhoneNumber + '">' + location.PhoneNumber + '</a>');
      $locationEmail.html('<a href="mailto:' + location.Email + '">' + location.Email + '</a>');
      $locationButton.attr('href', '' + location.Email);
      $locationButton.html('<a href="' + location.URL + '" class="btn btn--reset btn--primary"><span class="btn__text">' + $buttonText + '</span>' + arrowSvg + '</a>');

      if (location.FeatureImage.length > 0) {
        $locationImage.attr('src', '' + location.FeatureImage);
        $locationImage.show();
      } else {
        $locationImage.hide();
      }

      $locationPopup.addClass('is-active');
      map.setCenter(marker.getPosition());
    });

    return marker;
  });

  new _markerclusterer2.default(map, markers, {
    imagePath: clusterImage
  });

  var pageRequestManager = Sys.WebForms.PageRequestManager.getInstance();
  pageRequestManager.add_endRequest(initialiseViewMapLocation);

  function initialiseViewMapLocation() {
    var $viewLocation = $('.js-view-map-location');
    $viewLocation.on('click', function (e) {
      e.preventDefault();

      var $current = $(e.currentTarget);
      var latitude = $current.data('latitude');
      var longitude = $current.data('longitude');

      map.setCenter(new google.maps.LatLng(latitude, longitude));
      map.setZoom(12);
      $mapViewBtn.click();
    });
  }
  initialiseViewMapLocation();
};

self.initialise = function () {
  $locationPopupClose.on('click', function () {
    $locationPopup.removeClass('is-active');
  });
  $.post('/api/franchise', null, onLocationsLoaded);
};

module.exports = self;


// WEBPACK FOOTER //
// ./sitefiles/scripts/global/rebuild-components/init-google-map.js